/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Table, Modal, Typography } from "antd";
import {
  useApproveMutation,
  useLeavesListQuery,
  useRejectMutation,
} from "../../features/leave/leaveApi";
import LeaveStatus from "../../Components/LeaveStatus";
import LeaveStyle from "../../Components/LeavesStyle";
import moment from "moment";

const { Title } = Typography;

export default function Leaves() {
  const [approve, { data: approveData }] = useApproveMutation();
  const [reject, { data: rejectData }] = useRejectMutation();

  const [Approve, setApprove] = useState([]);
  const [Reject, setReject] = useState([]);

  const handleApprove = () => {
    approve(Approve);
    setApprove([]);
  };

  const handleReject = () => {
    reject(Reject);
    setReject([]);
  };

  const data = [
    {
      key: "name",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const columns = [
    {
      key: "name",
      title: "Leave Type",
      dataIndex: "name",
      ellipsis: true,
      render: (text) => <a>{text}</a>,
    },
    {
      key: "name",
      title: "Start Date",
      dataIndex: "start_date",
      render: (text) => <span>{moment(text).format("DD-MM-YYYY")}</span>,
      sortDirections: ["descend"],
    },
    {
      key: "name",
      title: "End Date",
      dataIndex: "end_date",
      render: (text) => <span>{moment(text).format("DD-MM-YYYY")}</span>,
    },
    {
      key: "name",
      title: "Duration",
      dataIndex: "duration",
      ellipsis: true,
    },
    {
      key: "name",
      title: "Leave Status",
      dataIndex: "status",
      render: (text) => <LeaveStatus status={text} />,
      ellipsis: true,
    },
    {
      key: "action",
      title: "Action",
      dataIndex: "action",
      render: (text, record, index) =>
        data.length >= 1 ? (
          <div style={{ display: "flex" }}>
            <span onClick={() => setReject(record)}>
              <a href="#">Reject</a>
            </span>
            /
            <span onClick={() => setApprove(record)}>
              <a href="#">Approve</a>
            </span>
          </div>
        ) : null,
    },
  ];
  return (
    <LeaveStyle>
      <Modal
        centered
        open={Approve.length !== 0}
        onOk={() => handleApprove()}
        onCancel={() => setApprove([])}
      >
        <Title level={5}>Are you sure want to approve this leave ? </Title>
      </Modal>
      <Modal
        centered
        open={Reject.length !== 0}
        onOk={() => handleReject()}
        onCancel={() => setReject([])}
      >
        <Title level={5}>Are you sure want to reject this leave ?</Title>
      </Modal>
      <Table
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        columns={columns}
        dataSource={data || []}
        pagination={false}
      />
    </LeaveStyle>
  );
}
